"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.signOperation = exports.applyEIP155 = exports.getSerializedTransaction = void 0;
var ethers_1 = require("ethers");
var rxjs_1 = require("rxjs");
var hw_app_eth_1 = __importStar(require("@ledgerhq/hw-app-eth"));
var buildOptimisticOperation_1 = require("./buildOptimisticOperation");
var prepareTransaction_1 = require("./prepareTransaction");
var adapters_1 = require("./adapters");
var deviceAccess_1 = require("../../hw/deviceAccess");
/**
 * Serialize a Ledger Live transaction into an hex string
 */
var getSerializedTransaction = function (account, tx, signature) {
    var unsignedEthersTransaction = (0, adapters_1.transactionToEthersTransaction)(tx);
    return ethers_1.ethers.utils.serializeTransaction(unsignedEthersTransaction, signature);
};
exports.getSerializedTransaction = getSerializedTransaction;
/**
 * Transforms the ECDSA signature paremeter v hexadecimal string received
 * from the nano into an EIP155 compatible number.
 *
 * Reminder EIP155 transforms v this way:
 * v = chainId * 2 + 35
 * (+ parity 1 or 0)
 */
var applyEIP155 = function (vAsHex, chainId) {
    var v = parseInt(vAsHex, 16);
    if (v === 0 || v === 1) {
        // if v is 0 or 1, it's already representing parity
        return chainId * 2 + 35 + v;
    }
    else if (v === 27 || v === 28) {
        var parity = v - 27; // transforming v into 0 or 1 to become the parity
        return chainId * 2 + 35 + parity;
    }
    // When chainId is lower than 109, hw-app-eth *can* return a v with EIP155 already applied
    // e.g. bsc's chainId is 56 -> v then equals to 147/148
    //      optimism's chainId is 10 -> v equals to 55/56
    //      ethereum's chainId is 1 -> v equals to 0/1
    //      goerli's chainId is 5 -> v equals to 0/1
    return v;
};
exports.applyEIP155 = applyEIP155;
/**
 * Sign Transaction with Ledger hardware
 */
var signOperation = function (_a) {
    var account = _a.account, deviceId = _a.deviceId, transaction = _a.transaction;
    return (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
        return new rxjs_1.Observable(function (o) {
            function main() {
                return __awaiter(this, void 0, void 0, function () {
                    var preparedTransaction, serializedTxHexString, eth, resolution, sig, _a, chainId, signature, operation;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                o.next({
                                    type: "device-signature-requested"
                                });
                                return [4 /*yield*/, (0, prepareTransaction_1.prepareForSignOperation)(account, transaction)];
                            case 1:
                                preparedTransaction = _b.sent();
                                serializedTxHexString = (0, exports.getSerializedTransaction)(account, preparedTransaction).slice(2);
                                eth = new hw_app_eth_1["default"](transport);
                                return [4 /*yield*/, hw_app_eth_1.ledgerService.resolveTransaction(serializedTxHexString, eth.loadConfig, {
                                        externalPlugins: true,
                                        erc20: true
                                    })];
                            case 2:
                                resolution = _b.sent();
                                return [4 /*yield*/, eth.signTransaction(account.freshAddressPath, serializedTxHexString, resolution)];
                            case 3:
                                sig = _b.sent();
                                o.next({ type: "device-signature-granted" }); // Signature is done
                                _a = (account.currency.ethereumLikeInfo || {}).chainId, chainId = _a === void 0 ? 0 : _a;
                                return [4 /*yield*/, (0, exports.getSerializedTransaction)(account, preparedTransaction, {
                                        r: "0x" + sig.r,
                                        s: "0x" + sig.s,
                                        v: (0, exports.applyEIP155)(sig.v, chainId)
                                    })];
                            case 4:
                                signature = _b.sent();
                                operation = (0, buildOptimisticOperation_1.buildOptimisticOperation)(account, __assign(__assign({}, transaction), { nonce: preparedTransaction.nonce }));
                                o.next({
                                    type: "signed",
                                    signedOperation: {
                                        operation: operation,
                                        signature: signature,
                                        expirationDate: null
                                    }
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            }
            main().then(function () { return o.complete(); }, function (e) { return o.error(e); });
        });
    });
};
exports.signOperation = signOperation;
exports["default"] = exports.signOperation;
//# sourceMappingURL=signOperation.js.map